import type { IssueAgeStatus } from "#app/lib/data";

/**
 * The three server age states plus `disabled` — a client-only sentinel for a
 * stage with no age config, which the server reports as an absent `age` rather
 * than as a fourth status. Anything that reads a status off the wire is an
 * `IssueAgeStatus`; only pickers and legends that offer "turn age off" widen
 * to this.
 */
export type AgeStatus = IssueAgeStatus | "disabled";

/** Status names as values, for computed keys and switch arms. `satisfies`
 *  makes tsc reject this list the moment the server set changes. */
export const AGE_STATUS = {
  onTrack: "onTrack",
  atRisk: "atRisk",
  offTrack: "offTrack",
  disabled: "disabled",
} as const satisfies Record<AgeStatus, AgeStatus>;

export const AGE_STATUS_CONFIG: Record<AgeStatus, {
  label: string;
  colorToken: string;
  decoColor: "green" | "orange" | "red" | "grey";
  background: "success" | "warning" | "destructive" | "muted";
}> = {
  onTrack: { label: "On Track", colorToken: "success", decoColor: "green", background: "success" },
  atRisk: { label: "At Risk", colorToken: "warning", decoColor: "orange", background: "warning" },
  offTrack: { label: "Off Track", colorToken: "destructive", decoColor: "red", background: "destructive" },
  disabled: { label: "Disable age", colorToken: "muted-foreground", decoColor: "grey", background: "muted" },
};
